import { orderBy } from 'lodash';
import coerceToSemver from 'semver/functions/coerce';

export function semverSort(versions: string[]) {
  return orderBy(
    versions,
    [
      (version) => (version === '' ? 1 : 0),
      (version) => (coerceToSemver(version) ? 1 : 0),
      (version) => coerceToSemver(version)?.major ?? 0,
      (version) => coerceToSemver(version)?.minor ?? 0,
      (version) => coerceToSemver(version)?.patch ?? 0,
      (version) => version,
    ],
    ['desc', 'desc', 'desc', 'desc', 'desc', 'asc'],
  );
}
